"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StereoPlanRoute = void 0;
const base_model_1 = require("../base-model");
const stereo_plan_route_schema_1 = require("./stereo-plan-route.schema");
class StereoPlanRoute extends base_model_1.BaseModel {
    constructor(data, skipValidation) {
        super(data, skipValidation);
    }
    getDefaults() {
        return {
            files: [],
        };
    }
    getSchema() {
        return stereo_plan_route_schema_1.stereoPlanRouteSchema;
    }
}
exports.StereoPlanRoute = StereoPlanRoute;
